import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataWithFilters } from '@app/interfaces/data-with-filters';
import { PaginatedResults } from '@app/interfaces/paginated-results';
import { PaginationResults } from '@app/interfaces/pagination-results';
import { ResponseSuccess } from '@app/interfaces/response-success';
import { environment } from '@envs/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService extends DataService {
  protected override url = environment.api_url;

  constructor(http: HttpClient) {
    super(http);
  }

  override get<T>(url: string, options?: object): Observable<T> {
    return super.get<T>(url, options);
  }

  override put<T>(url: string, body: any): Observable<T> {
    return super.put<T>(url, body);
  }

  getPaginatedResults<T>(
    url: string,
    obj?: object,
  ): Observable<PaginatedResults<T>> {
    return super.get<PaginatedResults<T>>(url, obj);
  }

  getPaginatedResultsWithFilters<DataType, FiltersType>(
    url: string,
    params?: object,
  ): Observable<DataWithFilters<PaginationResults<DataType>, FiltersType>> {
    return super
      .get<
        ResponseSuccess<PaginationResults<DataType>, FiltersType>
      >(url, params)
      .pipe(
        map(
          (
            response: ResponseSuccess<PaginationResults<DataType>, FiltersType>,
          ) => {
            const result = {
              data: response.data,
              filters: response.filters,
              currentFilters: response.currentFilters,
            } as DataWithFilters<PaginationResults<DataType>, FiltersType>;

            return result;
          },
        ),
      );
  }

  getAll<T>(url: string, obj: any = null): Observable<T[]> {
    obj = obj || {};
    if (!obj.exact) {
      obj['per-page'] = obj['per-page'] || 0;
    }
    return this.getPaginatedResults<T>(url, obj).pipe(
      map((result: PaginatedResults<T>) => {
        return result.results;
      }),
    );
  }

  getModels<T>(url: string, obj: any = null): Observable<T[]> {
    obj = obj || {};

    return this.getPaginatedResults<T>(url, obj).pipe(
      map((result: PaginatedResults<T>) => {
        return result.results;
      }),
    );
  }

  create<T>(
    endpoint: string,
    data: any = null,
    obj?: object,
    headers?: object,
  ): Observable<T> {
    return this.post<T>(endpoint, data, obj, headers);
  }
}
